// extracted by mini-css-extract-plugin
export default {"title":"title-cnUEw","titleText":"titleText-IACBS","content":"content-sjhJs","open":"open-sJbbu"};